import { render, staticRenderFns } from "./Vias.vue?vue&type=template&id=4cd157c8&"
import script from "./Vias.vue?vue&type=script&lang=js&"
export * from "./Vias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports